import React, { useState } from 'react';

type Props = {};

const MonthlyInvoicesPage = (props: Props) => {
  const [adFormat, setAdFormat] = useState<string>("");
  const [platformType, setPlatformType] = useState<string>("");
  const [trafficSourceType, setTrafficSourceType] = useState<string>("");

  const handleGenerate = () => {
    if (!adFormat || !platformType || !trafficSourceType) {
      alert("Please select all fields to generate traffic estimation.");
      return;
    }
    // Logic for fetching or calculating traffic estimation goes here
    console.log("Generating traffic estimation...");
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg max-w-lg mx-auto" style={{ padding: '30px', height: '80%', width: '60%', boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)' }}>
      <h2 className="text-x font-bold mb-4" style={{ fontSize: '12px' }}>Select invoices' year:</h2>
      

      <div className="space-y-4" style={{ display: 'flex' }}>
        <div>
         
          <select
            style={{ padding: '3px 30px', textAlign:'left', borderColor: '#D3D3D3', marginRight: '5px', fontSize: '12px', backgroundColor: '#F5F5F5', borderWidth: '0.1px' }}
            id="adFormat"
            className="p-2 border rounded-lg"
            value={adFormat}
            onChange={(e) => setAdFormat(e.target.value)}
          >
            <option value="">2021</option>
            <option value="banner">2022</option>
            <option value="video">2023</option>
            <option value="native">2024</option>
            <option value="native">2025</option>

          </select>
        </div>

        


        <button
          style={{ padding: '3px 10px', backgroundColor: '#81D34A', color: 'white', borderColor: 'transparent', fontSize: '10p' }}
          className="mt-6 w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
          onClick={handleGenerate}
        >
          Generate
        </button>
      </div>


    </div>
  );
};


export default MonthlyInvoicesPage;